// @ts-nocheck
import Login from 'src/pages/Login'

import { Navigate, Route, Routes } from 'react-router-dom'
import PublicRoute from './PublicRoute'

import { Suspense } from 'react'
import MainLayout from 'src/components/layouts/main'
import PrintSalesInvoice from 'src/pages/Print/PrintSalesInvoice'
import ProtectedRoute from './ProtectedRoute'
import { routes } from './routes'

const NavigationRoutes = () => {
  const _renderRoutes = routes?.map((item, idx) => {
    const Component = item?.component
    return <Route key={item.key} path={item?.path} element={<Component />} />
  })

  return (
    <Suspense>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>{_renderRoutes}</Route>
          <Route
            element={<PrintSalesInvoice />}
            key={'print-receipt-sales-invoice'}
            path={'/print/receipt/sales-invoice/:id'}
          />
        </Route>

        {/* public routes */}
        <Route path={'/login'} element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Suspense>
  )
}

export default NavigationRoutes
